var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseCircle = function SvgPauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.07c5.483 0 9.929 4.445 9.929 9.928S17.483 21.927 12 21.927s-9.928-4.446-9.928-9.929S6.517 2.071 12 2.07m0 1.2a8.73 8.73 0 1 0 .002 17.458A8.73 8.73 0 0 0 12 3.27M10.135 8.7a.5.5 0 0 1 .5.5v5.597a.5.5 0 0 1-1 0V9.2a.5.5 0 0 1 .5-.5m3.731 0a.5.5 0 0 1 .5.5v5.597a.5.5 0 0 1-1 0V9.2a.5.5 0 0 1 .5-.5"
  })));
};
export default SvgPauseCircle;